import { render, staticRenderFns } from "./stateSaleDialog.vue?vue&type=template&id=08263a94&"
import script from "./stateSaleDialog.vue?vue&type=script&lang=js&"
export * from "./stateSaleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports